module.exports = __webpack_public_path__ + "img/BD.61a9b0cc.svg";